// extracted by mini-css-extract-plugin
export default {"modal":"MediaModalWrap_modal__X4gWV","image":"MediaModalWrap_image__En3K9","modal_deleteBtn":"MediaModalWrap_modal_deleteBtn__6jkDZ","modal_wrap":"MediaModalWrap_modal_wrap__nzMZt"};